import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import { Dispatch, SetStateAction } from "react";
import { newTripIcon } from "../../../../constant";
import { APP_VERSION } from "../../../../constant/environment";
import SaveTrips from "./components/savedTrips/savedTrips";
import HistoryTab from "../history/historyOld";
import { CustomTabPanel } from "./components/CustomTabPanel";
import { DesktopTabs } from "./components/DesktopTabs";
import { MobileTabs } from "./components/MobileTabs";
import { useTabsLogic } from "./hooks/useTabsLogic";
import styles from "./tab.module.scss";

interface iProps {
  isOpenMobileSidebar?: boolean;
  setIsOpenMobileSidebar?: Dispatch<SetStateAction<boolean>>;
}

export default function BasicTabs({ setIsOpenMobileSidebar, isOpenMobileSidebar }: iProps) {
  const {
    value,
    setValue,
    tripCount,
    setTripCount,
    listItinery,
    setListItinery,
    isLoadingItineraryList,
    setIsLoadingItineraryList,
    handleChange,
    handleNav,
    handleLastTab,
    handleBook,
    showGetHelpOptions,
    setShowGetHelpOptions,
    userInfo,
    isMobile,
    currentTripData,
    setScreen,
    setMyTripActiveTab,
    dataProps,
  } = useTabsLogic({ setIsOpenMobileSidebar });

  if (!userInfo?.loggedIn && !isMobile)
    return (
      <div className={styles.main}>
        <Button className={styles.headBox} onClick={handleNav}>
          <p className={styles.title}>New Trip</p>
          <img src={newTripIcon} alt="" className={styles.editLogo} />
        </Button>
        <DesktopTabs
          value={value}
          handleChange={handleChange}
          currentTripData={currentTripData}
          userInfo={userInfo}
          showGetHelpOptions={showGetHelpOptions}
          setShowGetHelpOptions={setShowGetHelpOptions}
          setShowZoho={dataProps.setShowZoho}
          setLoginCreateAccountState={dataProps.setLoginCreateAccountState}
          setScreen={setScreen}
          setMyTripActiveTab={setMyTripActiveTab}
          resetBookingValues={dataProps.resetBookingValues}
          setFirstScreen={dataProps.setFirstScreen}
          sendPixelEvent={dataProps.sendPixelEvent}
          handleBook={handleBook}
          setActiveBreadCrumbs={dataProps.setActiveBreadCrumbs}
          setHotelData={dataProps.setHotelData}
          setFlightData={dataProps.setFlightData}
          setHideDetails={dataProps.setHideDetails}
          setValue={setValue}
        />
      </div>
    );

  return (
    <div className={styles.main}>
      <p className={styles.appVersion}>Version: {APP_VERSION}</p>
      {!isMobile && (
        <Button className={styles.headBox} onClick={handleNav} disableRipple disableFocusRipple disableTouchRipple>
          <p className={styles.title}>New Trip</p>
          <img src={newTripIcon} alt="" className={styles.editLogo} />
        </Button>
      )}

      <Box className={styles.box}>
        {isMobile ? (
          <MobileTabs
            value={value}
            handleChange={handleChange}
            setChatInputText={dataProps.setChatInputText}
            handleLastTab={handleLastTab}
          />
        ) : (
          <DesktopTabs
            value={value}
            handleChange={handleChange}
            currentTripData={currentTripData}
            userInfo={userInfo}
            showGetHelpOptions={showGetHelpOptions}
            setShowGetHelpOptions={setShowGetHelpOptions}
            setShowZoho={dataProps.setShowZoho}
            setLoginCreateAccountState={dataProps.setLoginCreateAccountState}
            setScreen={setScreen}
            setMyTripActiveTab={setMyTripActiveTab}
            resetBookingValues={dataProps.resetBookingValues}
            setFirstScreen={dataProps.setFirstScreen}
            sendPixelEvent={dataProps.sendPixelEvent}
            handleBook={handleBook}
            setActiveBreadCrumbs={dataProps.setActiveBreadCrumbs}
            setHotelData={dataProps.setHotelData}
            setFlightData={dataProps.setFlightData}
            setHideDetails={dataProps.setHideDetails}
            setValue={setValue}
          />
        )}
      </Box>
      {isMobile ? (
        <>
          <CustomTabPanel value={value} index={isMobile ? 0 : 1}>
            <HistoryTab isOpenMobileSidebar={isOpenMobileSidebar} setIsOpenMobileSidebar={setIsOpenMobileSidebar} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={isMobile ? 1 : 0}>
            <SaveTrips
              value={value}
              setTripCount={setTripCount}
              setIsOpenMobileSidebar={setIsOpenMobileSidebar}
              tripCount={tripCount}
              listItinery={listItinery}
              setListItinery={setListItinery}
              isLoadingItineraryList={isLoadingItineraryList}
              setIsLoadingItineraryList={setIsLoadingItineraryList}
            />
          </CustomTabPanel>
        </>
      ) : (
        <>
          {Array.from({ length: 9 }).map((_, idx) => (
            <CustomTabPanel value={value} index={idx} key={idx}>
              <HistoryTab isOpenMobileSidebar={isOpenMobileSidebar} setIsOpenMobileSidebar={setIsOpenMobileSidebar} />
            </CustomTabPanel>
          ))}
        </>
      )}
    </div>
  );
}
